import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid,Tab } from '@mui/material';
import { TabContext, TabList, TabPanel } from '@mui/lab';
import {
  Chart as ChartJS,
  CategoryScale,
  ArcElement,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2';
import CommonTable from 'components/commonTable/CommonTable';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import Loader from 'components/loader/Loader';
import { semiOptionsDoughnutCab } from 'components/chartComponent/ChartComponentData';
import { filterdata, cabRidedataFilter, driverFilter } from './CabRideData';
import FeedbackCard from './FeedbackCard';
import { NewPagination } from 'components/ui/newPagination';


ChartJS.register(
  ArcElement,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export default function RideDetailsTab(props) {

  const navigate = useNavigate();
  const handleChange = (event, newValue) => {
    
    props?.handleChange(newValue)
  };

  const role = localStorage.getItem('role')

  const onClickId = (val, from) => {
        // TODO: Commenting this code for UAT deployment, for further we required this feature
    // switch (from) {
    //   case 'dashboardRide':
    //     navigate(`/rideTrack/details`, {state: {id: val?.id, tripId:val?.tripId, status: val?.status, customer: val?.customerFullName, driver: val?.driverName, type: 'Ride', tabType:'dashboard' }});
    //     window.location.reload();
    //     break;
    //   case 'dashboardSubVendor':
    //     navigate(`/subvendor/details`, {state: {subVendorId:val?.id, status:val?.status, name:val?.name, companyId:val?.companyId, companyName: val?.companyName, tabType:'dashboard'}});
    //     break;
    //   case 'dashboardDriver':
    //     navigate(`/driver/details`, {state:{driverId:val?.id, status:val?.status, name:val?.fullName, id:val?.DriverProfile?.id, tabType:'dashboard'}});
    //     break;
    //   default:
    //     // Handle default case if needed
    //     break;
    // }
  };

  let filterData;
  switch (props?.value) {
    case '1':
      filterData = cabRidedataFilter;
      break;
    case '2':
      filterData = filterdata;
      break;
    case '3':
      filterData = filterdata;
      break;
    case '4':
      filterData = driverFilter;
      break;
    default:
      filterData = null;
      break;
  }

  return (
    <Grid container>
      <Grid item sm={12} md={8.4} className="tableContainer">
        <Box className="contentBoxStyle">
          <TabContext value={props?.value}>
            <Grid
              container
              className="tabBoxStyle tabPanelStyle"
              direction="row"
              justifyContent="space-between"
              alignItems="center"
            >
              <Grid item>
                <TabList
                  onChange={handleChange}
                  className="minHeight32"
                  aria-label="lab API tabs example"
                  TabIndicatorProps={{
                    style: { backgroundColor: 'none' }, 
                  }}
                  sx={{ indicatorColor: 'none' }}
                >
                  <Tab
                    label="Cab Ride Details"
                    value="1"
                    className="tabStyle"
                  />

                  { role !=='subVendorCompany' &&
                  <Tab label="Top Sub-Vendors " value="3" className="tabStyle" />}
                  <Tab label="Top Drivers" value="4" className="tabStyle" />
                  <Tab label="Subvendor Compliance Expiry" value="5" className="tabStyle" />
                </TabList>
              </Grid>
            </Grid>
            <TabPanel value="1" className="tabPanelStyleDashboard">
              {props?.isLoadingCabRide ? <Loader/> :
              <CommonTable 
                data={props?.tableDataDetails}
                from={'dashboardRide'}
                onClickId={onClickId}
                // isClickable = {true}
              />}
            </TabPanel>
            <TabPanel value="2" className="tabPanelStyleDashboard">
              <CommonTable
                data={props?.tableDataDetails}
                from={'dashboardVendor'}
                onClickId={onClickId}
                // isClickable = {true}
              />
            </TabPanel>
            <TabPanel value="3" className="tabPanelStyleDashboard">
            {props?.isLoadingTopSubVendor ? <Loader/> :
              <CommonTable
                data={props?.tableDataDetails}
                from={'dashboardSubVendor'}
                onClickId={onClickId}
                // isClickable = {true}
              />}
            </TabPanel>
            <TabPanel value="4" className="tabPanelStyleDashboard">
            {props?.isLoadingTopDriver ? <Loader/> :
              <CommonTable
                data={props?.tableDataDetails}
                from={'dashboardDriver'}
                onClickId={onClickId}
                // isClickable = {true}
              />}
            </TabPanel>
         <TabPanel value="5" className="tabPanelStyleDashboard">
  {props?.isLoadingComplianceTracker ? <Loader/> :
    <>
      <CommonTable
        data={props?.complianceTrackerData}
        from={'dashboardComplianceTracker'}
        showPagination={false}
        isClickable = {true}
        onClickId={(row) => props?.onClickComplianceRow(row)}
      />
      <NewPagination
        currentPage={props?.currentPage}
        totalItems={props?.totalItems}
        itemsPerPage={props?.itemsPerPage}
        onPageChange={props?.onPageChange}
        onItemsPerPageChange={props?.onItemsPerPageChange}
        className="border-t"
      />
    </>
  }
</TabPanel>


          </TabContext>
        </Box>
      </Grid>
      <Grid item sm={12} md={3.6} className="cardStyle">
        <Grid container>
          <Grid item className="marginbottom20 chatrtRowStyle marginTop15">
            {props?.ourCarData?.labels?.length > 0  ? <div className="semiChartWrap"><Doughnut
                id="doughnutChartCar"
                data={props?.ourCarData}
                options={semiOptionsDoughnutCab}
                plugins={[
                  {
                    beforeDraw(chart) {
                      const { ctx } = chart;
                      // Anchor to the arc's actual geometry so the text scales
                      // with the chart and never overlaps the ring/legend at
                      // different screen resolutions.
                      const arc = chart.getDatasetMeta(0)?.data?.[0];
                      if (!arc) return;
                      ctx.save();
                      const centerX = arc.x;
                      const centerY = arc.y;
                      const innerRadius = arc.innerRadius;

                      // Font size proportional to the ring so it fits inside it
                      const fontSize = Math.max(14, Math.min(innerRadius * 0.45, 20));
                      ctx.textAlign = 'center';
                      ctx.textBaseline = 'middle';

                      const text = props?.ourCarData?.datasets[0]?.data?.reduce(
                        (partialSum, a) => partialSum + a,
                        0
                      );
                      ctx.font = `bolder ${fontSize}px sans-serif`;
                      ctx.fillStyle = '#282828';
                      ctx.fillText(text, centerX, centerY - innerRadius * 0.45);

                      ctx.font = `10px sans-serif`;
                      ctx.fillStyle = '#969696';
                      ctx.fillText('Vehicle', centerX, centerY - innerRadius * 0.15);
                      ctx.restore();
                    },
                  },
                ]}
              /></div>: <CommonNoDataFound />
            }
          </Grid>
          <Grid item className="width100">
            <FeedbackCard dashboardFeedbackData={props?.dashboardFeedbackData} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
